module.exports = __webpack_public_path__ + "img/xuanxing_banner_tr.c974f5bf.jpg";